import React from "react";

interface OcrAccuracyScorecardProps {
  label: string;
  value: number | string | null;
  unit?: string;
  /** higher is better (default true); drives color coding */
  higherIsBetter?: boolean;
  greenThreshold?: number;
  yellowThreshold?: number;
}

const colorFor = (
  value: number,
  higherIsBetter: boolean,
  green: number,
  yellow: number
): string => {
  if (higherIsBetter) {
    if (value >= green) return "#16a34a";
    if (value >= yellow) return "#d97706";
    return "#dc2626";
  } else {
    if (value <= green) return "#16a34a";
    if (value <= yellow) return "#d97706";
    return "#dc2626";
  }
};

export const OcrAccuracyScorecard: React.FC<OcrAccuracyScorecardProps> = ({
  label,
  value,
  unit = "%",
  higherIsBetter = true,
  greenThreshold = 80,
  yellowThreshold = 60,
}) => {
  const color =
    value !== null
      ? colorFor(Number(value), higherIsBetter, greenThreshold, yellowThreshold)
      : "#6b7280";

  const displayValue =
    value !== null ? `${Number(value).toFixed(1)}${unit}` : "—";

  return (
    <div
      style={{
        background: "#ffffff",
        border: "1px solid #e5e7eb",
        borderRadius: 8,
        padding: "20px 24px",
        flex: 1,
        minWidth: 180,
      }}
    >
      <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 8 }}>{label}</div>
      <div style={{ fontSize: 32, fontWeight: 700, color }}>{displayValue}</div>
    </div>
  );
};
